import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface Props {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  reportName?: string;
}

const DeleteConfirmModal: React.FC<Props> = ({ show, onHide, onConfirm, reportName }) => {
  const { t } = useTranslation(['pages', 'common']);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('buttons.delete', { ns: 'common' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('customReports.confirmDelete')}</p>
        {reportName && <p className="text-muted mb-3"><strong>{reportName}</strong></p>}
        <p className="text-danger small">{t('messages.cannotBeUndone', { ns: 'common' })}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('buttons.cancel', { ns: 'common' })}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {t('buttons.delete', { ns: 'common' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmModal;
